import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import "./firebaseConfig";
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');

// react-snap prerendering: hydrate if pre-rendered HTML exists, otherwise render
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, <App />);
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(<App />);
}

reportWebVitals(console.log);
